<template>
  <div
      v-if="show"
      class="page-banner"
  >
    <div class="container-fluid position-relative">
      <div v-html="content" />
      <div>
        <span @click="isOpen = false">
          <FontAwesomeIcon :icon="faXmark"/>
        </span>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import {
  onBeforeMount,
  onMounted,
  ref,
  computed,
} from 'vue';

library.add(faXmark);

const pageBanner = window.ioappConfig.pageBanner[0];

const { content } = pageBanner;
const { shown } = pageBanner;
const startDate = pageBanner.start;
const endDate = pageBanner.end;

const isOpen = ref(true);
const inDateRange = ref(true);

const isInDateRange = () => {
  const today = new Date();
  if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    inDateRange.value = today >= start && today <= end;
  } else {
    inDateRange.value = false;
  }
};

const inSession = sessionStorage.getItem('banner') === 'true' && shown === 'session';

const show = computed(() => content && (inDateRange.value && !inSession) && isOpen.value);
onBeforeMount(() => {
  isInDateRange();
});

onMounted(() => sessionStorage.setItem('banner', 'true'));
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.page-banner {
  font-size: .75rem;
  color: #FFFFFF;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 0;
  padding: .833333em 0;
  font-weight: 700;

  @media(min-width: map-get($grid-breakpoints, 'lg')) {
    font-size: 1.125rem;
    padding: .44444em 0;
  }

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, #F93F4D 0%, #C7271A 100%);
    opacity: 0.8;
  }

  > div {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: start;

    > div {
      &:first-child {
        grid-template: 1 / 2;
        padding-right: 10px;
      }

      &:last-child {
        grid-template: 2 / 3;

        > span {
          cursor: pointer;
        }
      }
    }
  }

  a,
  a:hover {
    color: #FFFFFF;
    text-decoration: underline;
  }
}
</style>
